var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagScotland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.741 3.31824C23.0431 1.24443 19.6659 0.0107422 16 0.0107422C12.3341 0.0107422 8.95688 1.24449 6.25894 3.31824L16 13.0592L25.741 3.31824Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30744 6.26978C1.23375 8.96771 0 12.3449 0 16.0108C0 19.6767 1.23375 23.0539 3.3075 25.7519L13.0486 16.0108L3.30744 6.26978Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25894 28.7032C8.95694 30.777 12.3341 32.0107 16 32.0107C19.6659 32.0107 23.0431 30.7769 25.7411 28.7032L16 18.9622L6.25894 28.7032Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6922 25.7518C30.766 23.0538 31.9997 19.6767 31.9997 16.0108C31.9997 12.3449 30.766 8.96771 28.6922 6.26978L18.9512 16.0108L28.6922 25.7518Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagScotland);
export default __webpack_public_path__ + "static/media/flag_scotland.480e4abaad8354259c52a25b17bcb492.svg";
export { ForwardRef as ReactComponent };